export default __webpack_public_path__ + "static/media/soil_temperature.05c7822d.svg";